import { createStore } from 'vuex';
import axios from 'axios';
import {csv} from 'd3-fetch';

const d3 = {
  csv
}

export default createStore({
  state: {
    loading: true,
    content: [],
    overgewicht: null
  },
  mutations: {
    SAVE_CONTENT (state, data) {
      state.content = data;
      // console.log("content", state.content);
    }, 
    SAVE_OVERGEWICHT (state, data) {
      state.overgewicht = data;
      // console.log("overgewicht", data);
    }, 
  },
  actions: {
    loadData ({ commit, state }) {
      return new Promise((resolve, reject) => { 
        if(state.content.length > 0) {
          resolve();
          return;
        }

        axios.all([
            axios.get('https://data.kro-ncrv.nl/data/copy/2021-vet-marketing.json'),
            d3.csv(process.env.BASE_URL + "data/overgewicht.csv")
          ])
          .then(axios.spread((content, overgewicht) => {
            commit("SAVE_CONTENT", content.data);
            commit("SAVE_OVERGEWICHT", overgewicht);
            this.state.loading = false;
            resolve();
          }))
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },    
  },
  modules: {

  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  }
})
